import React from 'react'
import Banner from '../Components/Banner'
import CoinsTable from '../Components/CoinsTable'
const HomePage = () => {
  return (
    <>
  <Banner />
  <CoinsTable />

    </>
  )
}

export default HomePage
